import type { FC, ReactNode } from 'react';
import { cn } from '@/app/utils';

interface ToolMediaUploadHeaderProps {
  className?: string;
  titleClassName?: string;
  icon?: ReactNode;
  title?: ReactNode;
  extra?: ReactNode;
  rightSlot?: ReactNode;
}

export const ToolMediaUploadHeader: FC<ToolMediaUploadHeaderProps> = ({
  className,
  titleClassName,
  icon,
  title,
  extra,
  rightSlot,
}) => {
  return (
    <div className={cn('flex flex-wrap items-center gap-2', rightSlot && 'justify-between', className)}>
      {title && (
        <div className="flex min-w-0 items-center gap-1">
          {icon ? <div className="shrink-0">{icon}</div> : null}
          <div className="flex min-w-0 flex-wrap items-center gap-1">
            <div className={cn('font-medium text-base text-system-white leading-[1.4]', titleClassName)}>{title}</div>
            {extra ? <div className="flex items-center gap-1">{extra}</div> : null}
          </div>
        </div>
      )}
      {rightSlot ? <div className="shrink-0">{rightSlot}</div> : null}
    </div>
  );
};
